<template>
    <transition name="modal">
        <div class="modal" v-show="open" id="promote-modal">
            <div class="modal-overlay" @click="$emit('close')"/>
            <div class="modal-container">
                <button class="modal-close" @click="$emit('close')"><i class="fal fa-times"/></button>
                <p class="modal-container-headline">{{ $translations.notify.modal_headline }}</p>
                <div ref="modalEmbedContents" v-once v-html="embedCode" />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
	selector: "#vue-single-product-promote",
    props: {
        embedSelector: {
            type: String,
        },
        embedCode: {
            type: String,
            default: '',
        },
        open: {
            type: Boolean,
            required: true,
        }
    },
    watch: {
        open(open) {
            document.body.classList.toggle('lock', open);
            // focus first non-hidden input on open
            if (open) {
                const input = this.$refs.modalEmbedContents.querySelector('input:not([type="hidden"])');
                console.log('focus', input);
                if (input) {
                    this.$nextTick(() => {
                        input.focus();
                    })
                }
            }
        }
    },
    mounted() {
        if (this.embedSelector) {
            const form = document.querySelector(this.embedSelector);
            this.$refs.modalEmbedContents.appendChild(form);
            form.style.display = '';
        } else if (this.embedCode) {
            const re = /<script.*src="([^"]*)".*>/;
            const match = this.embedCode.match(re);
            if (match) {
                const scriptSrc = match[1];
                this.embedScript = document.createElement('script');
                this.embedScript.src = scriptSrc;
                document.body.appendChild(this.embedScript);
            }

        }
    },
    beforeDestroy() {
        if (this.embedScript) {
            this.embedScript.remove();
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    @include media("<=tablet") {
        width: 100%;
    }
}

.modal {
    z-index: z-index(promote-modal);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    
    display: flex;
    align-items: center;
    justify-content: center;

    &-enter-active,
    &-leave-active {
        transition: opacity 200ms ease-out;
    }

    &-enter,
    &-leave-to {
        opacity: 0;
    }
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(2px);
}

.modal-container {
    padding: 40px;
    background-color: white;
    border-radius: 4px;
    position: relative;
    max-width: 500px;
    max-height: 100vh;
    overflow-y: scroll;

    @include media("<=tablet") {
        padding: 24px;
    }
}

.modal-close {
    @include button-reset();
    position: absolute;
    top: 8px;
    right: 16px;
    font-size: 24px;
}

.modal-container-headline {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
}

#promote-modal ::v-deep form {
    padding: 0 !important;
    margin: 0 !important;
    width: auto !important;

    font-family: $font-family !important;

    label {
        font-size: 12px;
        font-weight: 200 !important;
    }

    ._form-content > * + * {
        margin-top: 24px;
    }

    input[type=text],
    input[type=email] {
        border-radius: 0 !important;
        border: none !important;
        border-bottom: 1px solid $black !important;

        &._has_error {
            border-color: #f37c7b !important;
        }
    }

    ._submit {
        display: inline-block !important;
        padding-left: 24px !important;
        padding-right: 24px !important;
        padding-top: 12px !important;
        padding-bottom: 12px !important;
        margin-top: 16px;
        border-radius: 4px !important;
        border: 2px solid $teal !important;
        border-color: $teal-light !important;
        color: $black !important;
        font-weight: 700 !important;
        font-size: 14px !important;
        text-align: center !important;
        text-decoration: none !important;
        background-color: $teal !important;
        background-color: transparent !important;
        transition: all 0.15s ease-in !important;

        &:hover {
            background-color: $teal-hover !important;
            border-color: $teal-hover !important;
            box-shadow: none !important;

            background-color: $teal-light !important;
            border-color: $teal-light !important;
            color: $white !important;
        }
    }
}

</style>